export default __webpack_public_path__ + "static/media/question.279c95da.svg";